'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import ReactGA from 'react-ga4';
import { useCookieConsent } from './CookieConsentContext';

export default function AnalyticsTracker() {
  const pathname = usePathname();
  const { settings } = useCookieConsent();

  useEffect(() => {
    const gaSetting = settings?.find(s => s.key === 'googleAnalytics');
    const gaEnabled = gaSetting?.enabled;

    if (!gaEnabled) return;

    ReactGA.send({
      hitType: 'pageview',
      page: pathname,
    });
  }, [pathname, settings]);

  return null;
}